<template lang="pug">
  div
    label.form-label Anexo
    .mb-2(v-if='anexo')
      div
        a(:href='anexo.url' target='_blank')
          img.s-rounded.img-responsive.c-hand(:src="anexo.thumb")
    .empty.my-2(v-else)
      .empty-icon
        i.fa.fa-search.fa-4x
      .empty-title.h5 Sem anexo
</template>

<script>
export default {
  props: { anexo: Object },
}
</script>
